import { epic$, store } from '@redux/store';
import marketingCampaignPreferencesSlice from './redux/slices'
import { unsubscribeEpic, unsubscribeFeedbackEpic } from './redux/epics';

epic$.next(unsubscribeEpic);
epic$.next(unsubscribeFeedbackEpic);

const { actions, reducer } = marketingCampaignPreferencesSlice;
store.injectReducer('marketingCampaignPreferences', reducer);
export {
    actions as marketingCampaignPreferencesActions,
    reducer as marketingCampaignPreferencesReducers,
}
